import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ExportOutlined } from '@ant-design/icons';
import styles from './index.module.css';

const Footer: FC = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.footer}>
            <div>{t('footer.copyright')}</div>
            <div className={styles.links}>
                <a
                    href="https://www.rozetta.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                >
                    {t('footer.about')} <ExportOutlined className={styles.icon} />
                </a>
                <a
                    href="https://www.rozetta.jp/rakuyaku_terms.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                >
                    {t('footer.terms')} <ExportOutlined className={styles.icon} />
                </a>
                <a
                    href="https://www.rozetta.jp/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                >
                    {t('footer.privacy')} <ExportOutlined className={styles.icon} />
                </a>
            </div>
        </div>
    );
};

export default Footer;
